<template>
  <div id="news">
    <page-title title="Nieuws en informatie" description="Overzicht van alle publicaties."></page-title>
    <router-link to="/new-info-item/new" class="btn btn-success btn-lg mb-3">+ item toevoegen</router-link>
    <div id="news-table" v-if="news.length">
      <table class="table table-hover">
        <thead class="thead-light">
          <tr>
            <th></th>
            <th>datum</th>
            <th>Titel</th>
            <th>status</th>
            <!-- <th>type</th> -->
            <th>acties</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in news" :key="item.id">
            <td>
              <img
                :src="item.images[0].url"
                alt
                class="img"
                width="48"
                v-if="item.images!=null && item.images.length>0"
              />
            </td>
            <td>
              <DateFormat :date="item.dateCreated" day></DateFormat>
            </td>
            <td>{{item.sections[0].title}}</td>
            <td>
              <button
                class="btn btn-sm btn-success"
                v-if="item.status=='live'"
                @click="toggleStatus(item)"
              >{{item.status == 'live' ? 'gepubliceerd' : 'concept'}}</button>
              <button
                class="btn btn-sm btn-warning"
                v-if="item.status!='live'"
                @click="toggleStatus(item)"
              >{{item.status}}</button>
            </td>
            <!-- <td>{{item.type}}</td> -->
            <td>
              <router-link :to=" { name: 'new-info-item', params: {id: item.id} }">
                <Icon icon="pencil" title="aanpassen" success></Icon>
              </router-link>
              <Icon icon="trash" title="verwijder" v-on:clicked="deleteItem(index)" danger></Icon>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      v-if="!news | !news.length"
    >Klik op de groene button en begin met het delen van nieuws met je medewerkers.</div>
  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");
var firestorage = fb.firestorage;

import { mapState } from "vuex";
import PageTitle from "@/components/PageTitle.vue";
import DateFormat from "@/components/DateFormat.vue";
import Icon from "@/components/icon.vue";

export default {
  name: "News",
  components: {
    PageTitle,
    DateFormat,
    Icon
  },
  computed: {
    ...mapState(["currentUser", "userProfile"])
  },
  data() {
    return {
      news: [],
      cid: this.$cookies.get("company")
    };
  },
  methods: {
    deleteItem(index) {
      this.$confirm({
        message: `Weet je zeker dat je dit item wilt verwijderen?`,
        button: {
          no: "annuleren",
          yes: "verwijderen"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          if (confirm) {
            // eerst de foto's
            var files = this.news[index].images;
            if (files) {
              files.forEach(img =>
                img.filename == ""
                  ? (img = 1.721)
                  : firestorage
                      .ref(
                        "information/" +
                          this.$cookies.get("company") +
                          "/" +
                          img.filename
                      )
                      .delete()
                      .catch(error => {
                        console.error(`file delete error occured: ${error}`);
                      })
              );
            }
            var id = this.news[index].id;
            fb.companiesCollection
              .doc(this.$cookies.get("company"))
              .collection("information")
              .doc(id)
              .delete()
              .then(() => this.news.splice(index, 1))
              .catch(function(e) {
                alert("Kon niet verwijderd worden");
                // TODO toast message
                console.log(e.message);
              });
          }
        }
      });
    },
    toggleStatus(item) {
      var status =
        item.status == "live"
          ? (item.status = "concept")
          : (item.status = "live");
      var id = item.id;
      fb.companiesCollection
        .doc(this.$cookies.get("company"))
        .collection("information")
        .doc(id)
        .update({ status: status })
        .then(() => (item.status = status))
        .catch(function(e) {
          alert("Kon niet aangepast worden");
          // TODO toast message
          console.log(e.message);
        });

      if (status !== "live") {
        return;
      }
      this.$confirm({
        message: `Wil je nu een automatische pushnotificatie sturen?`,
        button: {
          no: "overslaan",
          yes: "verzenden"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          var now = new Date();
          fb.notificationsCollection
            .add({
              type: "news",
              refid: id,
              date: now,
              created_by: this.$cookies.get("user"),
              title: item.sections[0].title,
              message:
                "Er is een nieuw bericht gepubliceerd. Je vindt dit in nieuws.",
              establishments:item.establishments,
              positions:item.positions,
              hidden: true,
              company: this.$cookies.get("company"),
              sendPush: confirm
            })
            .catch(error => console.log(error));
        }
      });
    }
  },
  created() {
    console.log("news ophalen");
    fb.companiesCollection
      .doc(this.$cookies.get("company"))
      .collection("information")
      .orderBy("date_created", "desc")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          console.log(doc.id);
          let d = doc.data();
          const data = {
            id: doc.id,
            canComment: d.can_comment,
            dateCreated: d.date_created, // new Date(d.date_created),
            images: d.images ?? [],
            sections: d.sections,
            status: d.status,
            type: d.type, // TODO later here only type news
            establishments: d.establishments,
            positions: d.positions
          };
          this.news.push(data);
        });
      });
  }
};
</script>